<template>
  <div class="login">
    <div class="login-lf">
      <Img src="/logo-login@2x.png" class="login-logo" />
      <Img src="/login1@2x.png" class="login-img" alt="" />
    </div>
    <div class="login-rg">
      <div>
        <h1>注册账户</h1>
        <Form ref="registerFormData" class="card_form" :model="registerFormData" :rules="registerRules" label-position="left">
          <FormItem prop="phone">
            <Input
              placeholder="请输入账户"
              type="text"
              :maxlength="11"
              v-model.trim="registerFormData.phone"
              @keyup.enter.native="handleSubmit('registerFormData')"
            />
          </FormItem>
          <div class="flex_nowrap">
            <FormItem prop="code" class="w250">
              <Input placeholder="请输入验证码" type="text" v-model.trim="registerFormData.code" @keyup.enter.native="handleSubmit('registerFormData')" />
            </FormItem>
            <div class="code_img" @click="getCode()"><img :src="code" /></div>
          </div>
          <FormItem prop="password">
            <Input
              placeholder="请输入密码"
              :type="showPwd ? 'text' : 'password'"
              v-model.trim="registerFormData.password"
              @keyup.enter.native="handleSubmit('registerFormData')"
            />
            <Img :src="showPwd ? '/eye-open@2x.png' : '/eye-close@2x.png'" class="eye" @click.native="showPwd = !showPwd" />
          </FormItem>
        </Form>
        <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('registerFormData')">注册</Button>
        <div class="tabs" @click="$router.push('/login')"><span>使用已有帐户登录</span></div>
      </div>
      <p class="copyright">Copyright© 2021 智谷星图出品</p>
      <span class="version" v-if="version">版本号：v{{ version }}</span>
    </div>
  </div>
</template>
<script>
import { Form, Input, Button, FormItem } from 'view-design'
import sha256 from 'js-sha256'
import { PhoneValid, PUValid } from '@/utils/check'
import Img from '../../components/Img.vue'
import { version } from '@/config'
export default {
  components: {
    Form,
    FormItem,
    Input,
    Button,
    Img
  },
  data() {
    return {
      version,
      showPwd: false, // 是否显示密码
      code: '',
      code_id: undefined,
      bannerList: [],
      // 登录form
      registerFormData: {
        phone: '',
        code: undefined,
        password: ''
      },
      // 登录验证
      registerRules: {
        phone: [
          { required: true, message: '请输入账户', trigger: 'blur' },
          { validator: PhoneValid, message: '手机号格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, message: '密码格式错误', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      // 注册验证
      regRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: PhoneValid, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, trigger: 'blur' }
        ],
        kind: [
          {
            required: true,
            type: 'number',
            message: '请选择身份',
            trigger: 'change'
          }
        ],
        authCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      handleBtnLoading: false //注册按钮状态
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    // 获取验证码
    async getCode() {
      const params = {
        uriCode: 'API005'
      }
      const res = await this.$fetch(params)
      this.code = res.code
      this.code_id = res.code_id
    },
    /**
     * 验证
     * name:表单名称
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.register()
        }
      })
    },
    // 注册
    async register() {
      this.handleBtnLoading = true
      const params = {
        uriCode: 'API002',
        ...this.registerFormData,
        code_id: this.code_id
      }
      params.password = sha256(this.registerFormData.password)
      try {
        const res = await this.$fetch(params)
        this.$msg.success('注册成功，请进行实名认证')
        localStorage.setItem('userPhone', this.registerFormData.phone)
        localStorage.setItem('userPassword', this.registerFormData.password)
        this.$router.push({ name: 'certification', query: { uid: res.uid } })
      } finally {
        this.handleBtnLoading = false
        this.getCode()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  display: flex;
  &-lf {
    width: 42%;
    background: #f5f9fc;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  &-logo {
    height: 30px;
    position: absolute;
    left: 50px;
    top: 50px;
  }
  &-img {
    height: 350px;
  }
  &-rg {
    width: 58%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    & > div {
      width: 368px;
      padding-bottom: 100px;
    }
  }
  h1 {
    font-size: 26px;
    color: #0e1b42;
    margin-bottom: 50px;
    text-align: center;
    line-height: 37px;
  }
  .prefix {
    display: flex;
    height: 100%;
    line-height: 48px;
    align-items: center;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.25);
    img {
      width: 15px;
      height: 15px;
      margin-right: 8px;
      display: inline-block;
    }
  }
  ::v-deep .ivu-form-item {
    margin-bottom: 32px;
  }
  ::v-deep .ivu-form-item-content {
    display: flex;
    background: #f7fafb;
    height: 48px;
    line-height: 48px;
    border-radius: 24px;
    padding: 0 35px 0 15px;
    input {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      outline: none;
      box-shadow: none;
    }
  }
  .eye {
    display: block;
    width: 18px;
    height: 18px;
    position: absolute;
    right: 12px;
    top: 15px;
    cursor: pointer;
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    position: absolute;
    bottom: 40px;
    width: 100%;
    text-align: center;
    font-size: 14px;
  }
  .version {
    position: absolute;
    bottom: 40px;
    right: 30px;
    font-size: 14px;
    color: #999;
  }
}
#app {
  .login_btn.ivu-btn-primary {
    background: #00af89;
    border-radius: 24px;
    width: 100%;
    box-shadow: none;
    border: none;
    height: 48px;
    margin-top: 86px;
  }
  ::v-deep .ivu-btn span {
    font-size: 16px;
  }
  .tabs {
    font-size: 14px;
    color: #1890ff;
    line-height: 24px;
    padding-left: 4px;
    text-align: center;
    margin-top: 10px;
    span {
      cursor: pointer;
    }
  }
  .flex_nowrap {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    justify-content: space-between;
  }
  .w250 {
    width: 250px;
  }
  .code_img {
    width: 100px;
    height: 48px;
    margin-left: 10px;
    background-color: #f2f2f2;
    cursor: pointer;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
/deep/ .ivu-form-item-error-tip {
  margin-left: 22px;
}
</style>
